import CommentPlaceholder from './CommentPlaceholder'

export default CommentPlaceholder
// eslint-disable-next-line import/export
export * from './CommentPlaceholder'
